import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

export const IssueDiscountCodeRequest = z.object({
  storeId: z.string(),
  couponName: z.string(),
  publicUserId: z.string(),
})

export type IssueDiscountCodeRequest = z.infer<typeof IssueDiscountCodeRequest>

export const IssueDiscountCodeResponse = z.object({})

export type IssueDiscountCodeResponse = z.infer<typeof IssueDiscountCodeResponse>

export const issueDiscountCodeDeclaration = endpointDeclaration(IssueDiscountCodeRequest, IssueDiscountCodeResponse)
